import e from "../managers/braze-instance.js";
import { logDeprecationWarning as z } from "../util/deprecation-utils.js";
export function logContentCardsDisplayed() {
  if (e.rr()) return z("logContentCardsDisplayed", "method"), !0;
}
